// start:ng42.barrel
import './components';
import './controllers';
import './controllers/groups';
import './controllers/status365';
import './reception.service';
import './register-file.service';
// end:ng42.barrel

